import { render, staticRenderFns, recyclableRender, components } from "./u-scroll-list.vue?vue&type=template&id=e2a26316&scoped=true&filter-modules=eyJ3eHMiOnsidHlwZSI6InNjcmlwdCIsImNvbnRlbnQiOiIiLCJzdGFydCI6MTg5OCwiYXR0cnMiOnsic3JjIjoiLi9zY3JvbGxXeHMud3hzIiwibW9kdWxlIjoid3hzIiwibGFuZyI6Ind4cyJ9LCJlbmQiOjE4OTh9fQ%3D%3D&"
var renderjs
import script from "./u-scroll-list.vue?vue&type=script&lang=js&"
export * from "./u-scroll-list.vue?vue&type=script&lang=js&"
import style0 from "./u-scroll-list.vue?vue&type=style&index=0&id=e2a26316&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../办公/HBuilderX.3.8.12.20230817/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2a26316",
  null,
  false,
  components,
  renderjs
)

/* custom blocks */
import block0 from "./scrollWxs.wxs?vue&type=custom&index=0&blockType=script&issuerPath=D%3A%5C%E8%B1%86%E7%B1%B3%5Cdingyuannongji%5Cmini-program%5Cnode_modules%5Cuview-ui%5Ccomponents%5Cu-scroll-list%5Cu-scroll-list.vue&module=wxs&lang=wxs"
if (typeof block0 === 'function') block0(component)

component.options.__file = "node_modules/uview-ui/components/u-scroll-list/u-scroll-list.vue"
export default component.exports